import type { PanelItem } from '@vedalib/editor/lib/elements'
import { createItem } from '@vedalib/editor/lib/elements/elements/LayoutList/constants'
import React from 'react'
import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldArray, FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import { useThroughElementItemsArrayEffect } from '../../utils/formEffects'
import LayoutListItemFormValue from './LayoutListItemFormValue'
import type { LayoutListFormValueType } from './layoutListTypes'

const ITEMS = genElementValueField({
  name: 'items',
  as: FieldArray<PanelItem>,
  props: {
    min: 1,
    defaultItem: createItem(),
    RenderItem: LayoutListItemFormValue,
  },
  useConfigs: [useThroughElementItemsArrayEffect],
})

const LayoutListForm: LayoutListFormValueType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <Typography styleType='hint'>{t('elements.layoutList.form.addSlideHint')}</Typography>
      <FormField config={chainName(name, ITEMS)} />
    </Padding>
  )
}

export default LayoutListForm
